import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-wavesine",
  "use": "icon-th-wavesine-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-wavesine\">\n<path d=\"M29.905 16.425C27.155 22.275 24.73 25 22.255 25C19.1175 25 17.1637 20.835 15.095 16.425C13.4625 12.945 11.6125 9 9.74999 9C7.69999 9 5.21124 13.6512 3.90999 16.425C3.79421 16.66 3.59084 16.8402 3.3436 16.9268C3.09636 17.0134 2.825 16.9996 2.58787 16.8882C2.35074 16.7769 2.16677 16.5769 2.07554 16.3313C1.98431 16.0857 1.99308 15.8142 2.09999 15.575C4.83874 9.725 7.26999 7 9.74999 7C12.8875 7 14.8412 11.165 16.91 15.575C18.5375 19.055 20.3875 23 22.25 23C24.3 23 26.7887 18.3488 28.09 15.575C28.2058 15.34 28.4091 15.1598 28.6564 15.0732C28.9036 14.9866 29.175 15.0004 29.4121 15.1118C29.6492 15.2231 29.8332 15.4231 29.9244 15.6687C30.0157 15.9143 30.0069 16.1858 29.9 16.425H29.905Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-wavesine.svg
// module id = w7UG
// module chunks = 84